/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import FormControl from 'react-bootstrap/FormControl'
import {
  addSubCategories,
  getCategoriesWithSubCategory,
  updateSubCategoriesOrder,
} from '../../../../../../API/api-endpoint'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import ToastUtils from '../../../../../../utils/ToastUtils'

const SubCategoryPlugins = () => {
  const [tableData, setTableData] = useState<any>([])
  const [getQuestionFlag, setGetQuestionFlag] = useState(1)
  const [currentAnswer, setCurrentAnswer] = useState<any>([])

  useEffect(() => {
    getAllQuestionWithAnswer()
  }, [getQuestionFlag])

  const getAllQuestionWithAnswer = async () => {
    let result = await getCategoriesWithSubCategory()
    setTableData(result.data)
  }

  const handleCurrentAnswerChange = (event: any, questionIndex: any) => {
    const currentAnswerData = [...currentAnswer]
    currentAnswerData[questionIndex] = event.target.value
    setCurrentAnswer(currentAnswerData)
  }

  const handleUpdateAnswer = async (questionIndex: any, questionId: any) => {
    const updatedTableData = [...tableData]
    let answerArray = updatedTableData[questionIndex].subCategory

    let answerText = currentAnswer[questionIndex]

    if (answerText !== undefined) {
      let result = await addSubCategories(answerText, answerArray.length + 1, questionId)
      if (result.success) {
        let oldAnswerDetails = [...currentAnswer]
        oldAnswerDetails[questionIndex] = ''
        setCurrentAnswer(oldAnswerDetails)
        setGetQuestionFlag(getQuestionFlag + 1)
      }
    }

    if (answerArray.length !== 0) {
      let response = await updateSubCategoriesOrder(answerArray)
      if (response.success) {
        setGetQuestionFlag(getQuestionFlag + 1)
        ToastUtils({type: 'success', message: 'Answer Was Updated'})
      } else {
        ToastUtils({type: 'error', message: 'Answer Was Not Updated'})
      }
    }
  }

  const handleExitingAnswer = (questionIndex: any, answerIndex: any, event: any) => {
    const updatedTableData = [...tableData]
    updatedTableData[questionIndex].subCategory[answerIndex].name = event.target.value
    setTableData(updatedTableData)
  }

  return (
    <KTCardBody className='py-4 '>
      <div className='card p-4 mb-4 fw-bold fs-6'>Sub Category By Category</div>
      <div>
        <div className='row g-5 g-xl-8'>
          {tableData !== undefined &&
            tableData.map((question: any, questionIndex: number) => {
              return (
                <div className='col-xl-4' key={questionIndex}>
                  <div className='card p-3' style={{height: '300px'}}>
                    <div className='d-flex justify-content-between'>
                      <h3 className='mt-3 fw-bold text-gray-800 fs-3'>{question.name}</h3>
                      <button
                        className='btn btn-light text-black'
                        onClick={() => handleUpdateAnswer(questionIndex, question._id)}
                      >
                        Update
                      </button>
                    </div>
                    <hr></hr>
                    <div className='h-200px overflow-scroll'>
                      {question.subCategory.map((answer: any, answerIndex: number) => {
                        return (
                          <FormControl
                            key={answerIndex}
                            name='answer'
                            value={answer.name}
                            onChange={(event) =>
                              handleExitingAnswer(questionIndex, answerIndex, event)
                            }
                            className='border border-0'
                          />
                        )
                      })}

                      <FormControl
                        placeholder='Add Sub category'
                        name='answer'
                        value={currentAnswer[questionIndex]}
                        onChange={(event) => handleCurrentAnswerChange(event, questionIndex)}
                        className='border border-0'
                      />
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </KTCardBody>
  )
}

export default SubCategoryPlugins
